<template>
	<div class="about-us-section">
		<div class="scroll-section1">
			<img src="images/abuot-us-scroll-section1-pc-01.png" alt="">
		</div>
		<div class="scroll-section2">
			<div class="section">
				<div :class="{item: true, active: type == 1}" v-on:click="typeChangeFun(1, 'anchorPoint1')">公司简介</div>
				<div :class="{item: true, active: type == 2}" v-on:click="typeChangeFun(2, 'anchorPoint2')">核心优势</div>
				<div :class="{item: true, active: type == 3}" v-on:click="typeChangeFun(3, 'anchorPoint3')">用户价值</div>
				<div :class="{item: true, active: type == 4}" v-on:click="typeChangeFun(4, 'anchorPoint4')">智慧基因</div>
				<div :class="{item: true, active: type == 5}" v-on:click="typeChangeFun(5, 'anchorPoint5')">使命</div>
				<!-- <div class="item">合作洽谈</div> -->
			</div>
		</div>
		<div id="anchorPoint1"></div>
		<div class="scroll-section3">
			<h1 class="header">护工来啦</h1>
			<div class="section">
				<p>护工来啦（上海）科技有限公司是恺邻集团旗下平台服务公司。</p>
				<p>“护工来啦”是一个智慧护理平台，整合百度AI技术，专注居家护理，线上线下O2O布局，打造垂直护理行业生态，从中台建设、产品研发、到人员招募和培训、再到人员评估和就业，着力建设人员评估&认证标准、运营管理体系标准、评估监督体系标准。</p>
				<p>业务涵盖G端政府客户，如长护险居家护理、居家养老服务、重残人员护理，B端客户面对医院和养老院、保险等金融机构的护理，C端客户（一对一护理、母婴护理、康复服务包）。</p>
				<p>目前固定服务对象近万人，全职护理员工近千人，平台注册护理人员5000多人。</p>
			</div>
			<div class="footer">
				<img src="images/abuot-us-scroll-section3-pc-01.jpg" alt="">
			</div>
		</div>
		<div id="anchorPoint2"></div>
		<div class="scroll-section4" >
			<h1 class="header">核心优势</h1>
			<div class="section">
				<h1>1、完备的产业闭环</h1>
				<p>产品研发->人员招募->人员培训->人员评估->人员就业</p>
				<h1>2、周全的业务布局</h1>
				<div class="others">
					<div>
						<p><span>50%</span>G端业务（长护险护理、居家养老服务、重残护理）</p>
						<p><span>30%</span>B端业务（医院、养老院、保险等金融机构）</p>
						<p><span>20%</span>C端业务（一对一护理、母婴护理、康复服务包）</p>
					</div>
				</div>
				<h1>3、共享的生态平台</h1>
				<p>建设行业标准、共享行业经验、主动行业赋能。</p>
				<h1>4、独有的可复制性</h1>
				<p>基于“护工来啦”中台管理，GBC端业务融合，根据区域发展，渐次切入。</p>
				<h1>5、先进的智慧基因</h1>
				<p>基于鼎鼎大名的百度AI技术，在不同的护理场景，应用了很多百度先进的AI技术，提升了客户体验，提高了护理行业服务品质和效率。</p>
			</div>
		</div>
		<div id="anchorPoint3"></div>
		<div class="scroll-section5">
			<div class="section">
				<h1>用户价值</h1>
				<h2>服务可达</h2>
				<p>服务人员、服务品质可以稳定获得</p>
				<h2>服务可信</h2>
				<p>培训、标准、制度保障服务人员、服务品质可信</p>
				<h2>服务可控</h2>
				<p>完备的产业闭环，保障服务人员、服务品质可控</p>
				<h2>服务可估</h2>
				<p>评估监管标准体系，服务可监督</p>
				<img src="images/abuot-us-scroll-section5-pc-01.png" alt="">
			</div>
		</div>
		<div id="anchorPoint4"></div>
		<div class="scroll-section6">
			<img src="images/abuot-us-scroll-section6-pc-01.png" alt="">
			<div class="mask">
				<h1>“护工来啦”先进的智慧基因</h1>
			</div>
		</div>
		<div id="anchorPoint5"></div>
		<div class="scroll-section7">
			<div class="left-view">
				<h1>“护工来啦”使命</h1>
				<h2>让照护有温度、使护理更智慧</h2>
			</div>
			<div class="line"></div>
			<p class="right-view">为了加强客户体验，减轻护理人员工作轻度，实时监测护理服务水平和照护对象生命特征，在护理平台建设伊始，就广泛对接各种护理服务场景的智能设备。例如紧急呼叫器，解决服务对象遇到危急时第一时间呼叫调度中心和就近护理人员。智能床垫，监测离床频率和周期，监测睡眠质量。应用最广泛的就是鼎鼎大名的百度AI技术，小度助手（DuerOS），这是最适合老人和照护对象使用的智能操作系统，也是推动时代变革的人机交互技术。</p>
		</div>
		<div class="scroll-section8">
			<h1>欢迎多方业务交流，可关注“护工来啦”公众号。</h1>
		</div>
	</div>
</template>

<script>
	export default{
		name: "AboutUsPC",
		data(){
			return {
				type: 1
			}
		},
		methods:{
			typeChangeFun (value, domeId){
				this.type = value;
				var scrollTop = document.getElementById(domeId).offsetTop;
				util.scrollTo(scrollTop);
			}
		}
	}
</script>

<style scoped="scoped">
	.scroll-section1{
		width: 100%;
	}
	.scroll-section1>img{
		width: 100%;
		display: block;
	}
	.scroll-section2{
		width: 100%;
		height: 0.6rem;
		background: #F4F4F4;
	}
	.scroll-section2>.section{
		width: 100%;
		height: 100%;
		max-width: 12rem;
		margin: 0 auto;
		display: flex;
		align-items: center;
		justify-content: flex-start;
		padding: 0 0.6rem;
		box-sizing: border-box;
		position: relative;
	}
	.scroll-section2>.section>.item{
		flex-shrink: 0;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-left: 0.6rem;
		font-size:0.18rem;
		font-family:Microsoft YaHei;
		font-weight:400;
		line-height:1.5;
		color: #333333;
		text-decoration: none;
		border-bottom: 0.04rem solid transparent;
		box-sizing: border-box;
		cursor: pointer;
	}
	.scroll-section2>.section>.item.active{
		border-color: #4788F4;
	}
	.scroll-section3,
	.scroll-section4,
	.scroll-section5,
	.scroll-section6,
	.scroll-section7,
	.scroll-section8{
		width: 12rem;
		margin: 0.86rem auto 0 auto;
	}
	.scroll-section3{
		width: 9.6rem;
	}
	.scroll-section3>.header{
		font-size:0.3rem;
		font-family:YouSheBiaoTiHei;
		font-weight:400;
		line-height:1.3;
		color:#333333;
		text-align: center;
	}
	.scroll-section3>.section{
		font-size:0.18rem;
		font-family:Microsoft YaHei;
		font-weight:400;
		line-height:1.6;
		color:#666666;
	}
	.scroll-section3>.section>p{
		margin: 0.1rem 0 0 0;
		text-indent: 2em;
	}
	.scroll-section3>.footer{
		margin-top: 0.64rem;
	}
	.scroll-section3>.footer>img{
		width: 100%;
		display: block;
	}
	.scroll-section4>.header{
		width:100%;
		height:1.1rem;
		background: #4788F4;
		line-height: 1.1rem;
		text-align: center;
		font-size:0.3rem;
		font-family:YouSheBiaoTiHei;
		font-weight:400;
		color:#FFFFFF;
	}
	.scroll-section4>.section{
		padding-top: 0.06rem;
	}
	.scroll-section4>.section>h1{
		text-align: center;
		margin-top: 0.3rem;
		font-size:0.2rem;
		font-family:Microsoft YaHei;
		font-weight:bold;
		line-height:1.3;
		color:#4788F4;
	}
	.scroll-section4>.section>P,
	.scroll-section4>.section>.others p{
		width:6rem;
		font-size:0.18rem;
		font-family:Microsoft YaHei;
		font-weight:400;
		line-height:1.5;
		color:#333333;
		text-align: center;
		margin: 0.2rem auto 0 auto;
	}
	.scroll-section4>.section>.others{
		margin: 0.2rem auto 0 auto;
		display: flex;
		align-items: flex-start;
		justify-content: center;
	}
	.scroll-section4>.section>.others p{
		width: auto;
		text-align: left;
		margin: auto;
	}
	.scroll-section4>.section>.others p>span{
		color: #4788F4;
	}
	.scroll-section5{
		width: 100%;
		background: #F2F2F2;
	}
	.scroll-section5>.section{
		width: 100%;
		max-width: 12rem;
		margin: 0 auto;
		position: relative;
		padding: 0.54rem 1.2rem;
		box-sizing: border-box;
	}
	.scroll-section5>.section>h1{
		font-size:0.3rem;
		font-family:YouSheBiaoTiHei;
		font-weight:400;
		line-height:1.3;
		color:#333333;
	}
	.scroll-section5>.section>h2{
		font-size:0.2rem;
		font-family:YouSheBiaoTiHei;
		font-weight:400;
		line-height:1.3;
		color:#333333;
		margin-top: 0.3rem;
	}
	.scroll-section5>.section>p{
		font-size:0.18rem;
		font-family:Microsoft YaHei;
		font-weight:400;
		line-height:1.3;
		color:#333333;
		margin: 0.18rem auto auto auto;
	}
	.scroll-section5>.section>img{
		position: absolute;
		top: 0;
		left: 5.1rem;
		height: 100%;
		z-index: 9;
	}
	.scroll-section6{
		width: 9.6rem;
		position: relative;
	}
	.scroll-section6>img{
		width: 100%;
		display: block;
	}
	.scroll-section6>.mask{
		position: absolute;
		top: 0;
		left: 0;
		z-index: 9;
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		background: rgba(0,0,0,0.65);
	}
	.scroll-section6>.mask>h1{
		font-size:0.3rem;
		font-family:YouSheBiaoTiHei;
		font-weight:400;
		line-height:1.3;
		color:#FFFFFF;
	}
	.scroll-section7{
		background: #F2F2F2;
		padding: 0.64rem 0.32rem;
		box-sizing: border-box;
		display: flex;
		align-items: center;
		justify-content: flex-start;
	}
	.scroll-section7>.left-view{
		flex-shrink: 0;
		margin-right: 0.32rem;
		display: flex;
		align-items: flex-start;
		justify-content: space-between;
		flex-direction: column;
	}
	.scroll-section7>.left-view>h1{
		font-size:0.3rem;
		font-family:YouSheBiaoTiHei;
		font-weight:400;
		line-height:1.3;
		color:#4788F4;
	}
	.scroll-section7>.left-view>h2{
		font-size:0.2rem;
		font-family:YouSheBiaoTiHei;
		font-weight:400;
		line-height:1.3;
		color:#4788F4;
	}
	.scroll-section7>.line{
		width:0.02rem;
		min-width: 2px;
		height:0.98rem;
		background:#4788F4;
		flex-shrink: 0;
		margin-right: 0.32rem;
	}
	.scroll-section7>.right-view{
		width:1px;
		flex: 1 1 auto;
		font-size:0.18rem;
		font-family:Microsoft YaHei;
		font-weight:400;
		line-height:1.6;
		color:#333333;
	}
	.scroll-section8{
		display: flex;
		align-items: center;
		justify-content: center;
		margin-bottom: 1rem;
	}
	.scroll-section8>h1{
		font-size:0.3rem;
		font-family:YouSheBiaoTiHei;
		font-weight:400;
		line-height:1.3;
		color:#4788F4;
	}
</style>
